// extracted by mini-css-extract-plugin
module.exports = {"keywordsTitle":"EzloNotificationTemplateKeywords_keywordsTitle__2tgcY","keywordsUsageDescription":"EzloNotificationTemplateKeywords_keywordsUsageDescription__2cjz4"};